module.exports = __webpack_public_path__ + "img/tile-fnb2.56812ead.jpg";